import React from 'react'

import { AppContext } from '@/components/base/appcontext'
import LinkWithState from '@/components/base/link'

import { Typography } from '@/components/ui/typography'

import { ChevronRight } from 'lucide-react'

// Frame of a card inside a CarouselRow.
export const CAROUSEL_CARD = 'w-[85%] flex-shrink-0 rounded-xl'

// Horizontally scrolling row of cards with an optional trailing "see more"
// link, or the row's empty state (an EmptyState) when there is nothing.
const CarouselRow: React.FC<{
    empty: boolean
    emptyState: React.ReactNode
    seeMoreLink?: string
    children: React.ReactNode
}> = ({ empty, emptyState, seeMoreLink, children }) => {
    const appContext = React.useContext(AppContext)

    if (empty) return <>{emptyState}</>

    return (
        <ul className="w-full flex flex-row gap-2 overflow-x-auto pb-1 -mb-1">
            {children}
            {seeMoreLink && (
                <li className="flex items-center justify-center w-20 flex-shrink-0 px-1">
                    <LinkWithState
                        to={seeMoreLink}
                        className="flex flex-col items-center gap-1.5 w-full text-muted-foreground hover:text-primary transition-colors"
                    >
                        <div className="h-9 w-9 rounded-full bg-muted flex items-center justify-center">
                            <ChevronRight className="h-4 w-4" />
                        </div>
                        <Typography
                            variant="body-xs"
                            className="text-center leading-tight text-balance break-words w-full"
                        >
                            {appContext.geti18n('trands.panel.seeMore')}
                        </Typography>
                    </LinkWithState>
                </li>
            )}
        </ul>
    )
}

export default CarouselRow
